import { render } from "./PanelFooter.vue?vue&type=template&id=03f534ec&scoped=true"
import script from "./PanelFooter.vue?vue&type=script&lang=js"
export * from "./PanelFooter.vue?vue&type=script&lang=js"

import "./PanelFooter.vue?vue&type=style&index=0&id=03f534ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f534ec"]])

export default __exports__